import { Component, Input, OnChanges, OnInit, SimpleChanges, input } from '@angular/core';
import { ZiroFormAbstractDirective } from '../../../../forms/ziro-form-abstract.directive';
import { ZiroFormConfig } from '../../../../forms/ziro-forms-models';
import {
  HtmlCheckboxType,
  HtmlSwitchSize,
  ZiroCheckboxConfig,
} from '../../../../forms/fields/checkbox/ziro-checkbox.component';
import { Observable, of } from 'rxjs';
import { ZiroFormStateService } from '../../../../forms/ziro-form-state.service';

export interface DnAgentExtensionForm {
  agentExtension: string;
}

interface DnAgentExtensionFormData {
  agentExtension: boolean;
}

@Component({
  selector: 'ziro-directory-number-agent-extension-form',
  templateUrl: './directory-number-agent-extension-form.component.html',
  standalone: false,
})
export class DirectoryNumberAgentExtensionFormComponent
  extends ZiroFormAbstractDirective<DnAgentExtensionForm, DnAgentExtensionFormData>
  implements OnInit, OnChanges
{
  protected _ziroFormStateService: ZiroFormStateService;

  protected formConfig: ZiroFormConfig;
  // TODO: Skipped for migration because:
  //  This input is inherited from a superclass, but the parent cannot be migrated.
  @Input() entity: DnAgentExtensionForm;
  readonly dnExtension = input<string>();

  private _isToggleDisabled = false;
  paramExtension: string;

  ngOnInit(): void {
    if (this.entity.agentExtension && this.entity.agentExtension !== this.dnExtension()) {
      this._isToggleDisabled = true;
      this.paramExtension = this.entity.agentExtension;
    }
    this._initFormConfig();
  }

  private _initFormConfig(): void {
    this.formConfig = {
      fields: {
        agentExtension: {
          label: 'Agent Extension',
          dataAutomation: 'dn-agent-extension-checkbox',
          componentConfig: new ZiroCheckboxConfig({ checkboxType: HtmlCheckboxType.SWITCH, size: HtmlSwitchSize.LG }),
          disabled: () => this._isToggleDisabled,
          disabledTooltip: {
            content: 'tkey;shared.dnWizard.dnDetails.uccx.toggle.disabled_message',
            params: { extension: this.paramExtension },
          },
        },
      },
    } as ZiroFormConfig;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.dnExtension &&
      !changes.dnExtension.firstChange &&
      changes.entity?.currentValue?.agentExtension === changes.dnExtension.previousValue
    ) {
      this.entity.agentExtension = changes.dnExtension.currentValue;
    }
    super.ngOnChanges(changes);
  }

  toFormData = (entity: DnAgentExtensionForm): DnAgentExtensionFormData => {
    const dnExtension = this.dnExtension();
    if (!entity.agentExtension) {
      return { agentExtension: false };
    } else if (entity.agentExtension === dnExtension) {
      this._isToggleDisabled = false;
      return { agentExtension: true };
    } else if (entity.agentExtension !== dnExtension) {
      return { agentExtension: false };
    }
  };

  toEntity = (formData: DnAgentExtensionFormData): DnAgentExtensionForm => {
    if (formData.agentExtension === true) {
      return { agentExtension: this.dnExtension() };
    } else {
      return { agentExtension: '' };
    }
  };

  protected submit(): Observable<null> {
    return of(null);
  }
}
